import { render } from "./InputFreetextDev.vue?vue&type=template&id=500d44e0"
import script from "./InputFreetextDev.vue?vue&type=script&lang=js"
export * from "./InputFreetextDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__